import React from 'react'
import { connect } from 'react-redux'
import CardProject from '../molecules/CardProject'

class SkillTemplate extends React.Component{
  constructor (props){
    super(props)
    this.template=undefined
    this.tamaños=[]
  }

  componentDidMount(){
    document.documentElement.scrollTop=0
    this.getTemplates()
    this.scrollea()
    window.addEventListener('scroll',()=>{
      this.scrollea()
    })
  }

  getTemplates=()=>{
    document.documentElement.scrollTop=0
    this.template=document.querySelectorAll('.skill-template')
    for (let i = 0; i < this.props.skills.length; i++) {
      if (i===0){
        this.tamaños.push([-10,this.template[i].getBoundingClientRect().y+(this.template[i].getBoundingClientRect().height-(this.template[i].getBoundingClientRect().height/5))])
      }
      else {this.tamaños.push([this.tamaños[i-1][1],this.template[i].getBoundingClientRect().y+(this.template[i].getBoundingClientRect().height-(this.template[i].getBoundingClientRect().height/5))])}
    }
  }

  scrollea=function(){
      var scroll = document.documentElement.scrollTop || document.body.scrollTop;
  
      for (let i = 0; i < this.props.skills.length; i++) {
        if (this.tamaños && document.getElementById(this.props.skills[i].id)){
        if(scroll > this.tamaños[i][0] && scroll < this.tamaños[i][1]){
          document.getElementById(this.props.skills[i].id).classList.add('active');
          this.props.skills.forEach(s=>{
            if (s.id!==this.props.skills[i].id){
              document.getElementById(s.id).classList.remove('active');
            }
          })
        }
        }
      }
  }


  render() {
    return (
    <div id={`${this.props.title}`} className="skill-template">
        <h1>{this.props.title}</h1>
        <div className="skill-projects">
          {
            this.props.data
            ?this.props.data.map(p=>(
                <CardProject video={p.video} key={p.id} id={p.id} images={p.images} image={p.images[0]} longDescription={p.longDescription} url={p.url} description={p.shortDescription} tools={p.tools}/>
            ))
            :<></>
          }
        </div>
    </div>
  )}
}
const mapStateToProps=state=>(
  {
    skills:state.data.skills
  }
)

export default connect(mapStateToProps,{})(SkillTemplate)
